/*
 * @Author: your name
 * @Date: 2019-05-28 22:51:41
 * @LastEditTime: 2020-11-05 11:40:47
 * @LastEditors: OBKoro1
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import Vant from 'vant'
import 'vant/lib/index.css'

import { Select, Option } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'


import Share from '@/components/Share'
Vue.component('Share', Share)

Vue.use(Select)
Vue.use(Option)


// import { pca, pcaa } from 'area-data'; // v5 or higher
// import 'vue-area-linkage/dist/index.css'// v2 or higher
// import VueAreaLinkage from 'vue-area-linkage'

// Vue.use(VueAreaLinkage)

// import fastclick from 'fastclick' 
// fastclick.attach(document.body)

Vue.use(Vant)
// import { Checkbox, CheckboxGroup } from 'vant'

// Vue.use(Checkbox).use(CheckboxGroup)
Vue.config.ignoredElements = ['wx-open-launch-weapp']
Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  store,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js